module.exports = __webpack_public_path__ + "static/barbarian-days-c09c4e30d95750b780ade2b068c32119.jpg";